jQuery(document).ready(function () {
    if ($('.videogallery').length > 0) {
        var youtubeThumbnail = require('../../../../../assets-builder/node_modules/youtube-thumbnail');

        /* Small video*/
        var videoNumber = $(".videogallery_smallVideoContainer").length;
        for ( var i=1; i < videoNumber +1; i++){
            var href = $("."+ i +"").children().attr('href');
            var thumbnail = youtubeThumbnail(href);
            var backgroundImg = thumbnail.high.url;
            $("."+ i +"").css("background-image", "url(" + backgroundImg + ")");
        }
         /* Main video*/
         var href = $(".videogallery_mainVideoContainer").children().attr('href');
         var thumbnail = youtubeThumbnail(href);
         var backgroundImg = thumbnail.high.url;
         $(".videogallery_mainVideoContainer").css("background-image", "url(" + backgroundImg + ")");

    }
    if (window.matchMedia("(max-width: 1023px)").matches || ($(".videogallery_smallVideoContainer").length > 3)) {
        $('.videogallery_container').slick({
            speed: 300,
            slidesToShow: 1,
            variableWidth: true,
            dots: false,
            infinite: false,
            prevArrow: null,
            nextArrow: null
        });
    }
});
